import React, { PureComponent } from 'react'
import './styles.css'
import PropTypes from 'prop-types'

class Loader extends PureComponent {
  render () {
    return (
      <div className="Loader" style={{ backgroundSize: this.props.size + 'px' }}/>
    )
  }
}

Loader.defaultProps = {
  size: 32
}
Loader.propTypes = {
  size: PropTypes.number
}

export default Loader
